import { CONNECTS_API_SLUG, NEXUS_API_SLUG } from 'src/constants'
import { FunctionComponent, useState } from 'react'
import { Search, useGetNodes } from '@stoplight/elements-dev-portal'

import { Box } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import type { NodeSearchResult } from '@stoplight/elements-dev-portal'
import SearchIcon from '@mui/icons-material/Search'

// TODO (SPD-554): add v2 projects (Nexus, Connects and Payments here to enable search)
const PROJECT_ID_TO_PROJECT_SLUG = {
  [process.env.REACT_APP_STOPLIGHT_CONNECTS_API_ID as string]: CONNECTS_API_SLUG,
  [process.env.REACT_APP_STOPLIGHT_NEXUS_API_ID as string]: NEXUS_API_SLUG
}

const SearchAPIDocs: FunctionComponent = () => {
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const projectIds = Object.keys(PROJECT_ID_TO_PROJECT_SLUG)
  const { data } = useGetNodes({
    search,
    projectIds
  })

  const handleClose = () => {
    setOpen(false)
    setSearch('')
  }

  const handleClick = (data: NodeSearchResult) => {
    const projectSlug = PROJECT_ID_TO_PROJECT_SLUG[data.project_id]
    const uri = `${projectSlug}/${data.slug}`
    const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https'

    window.location.href = `${protocol}://${window.location.host}/${uri}`
  }

  return (
    <Box>
      <>
        <IconButton
          color="inherit"
          size="medium"
          aria-label="search"
          onFocus={() => setOpen(true)}
          data-testid="search-icon"
        >
          <SearchIcon />
        </IconButton>
      </>
      <Search
        search={search}
        onSearch={setSearch}
        onClick={handleClick}
        onClose={handleClose}
        isOpen={open}
        searchResults={data}
        data-testid="search-portal"
      />
    </Box>
  )
}

export default SearchAPIDocs
